/* global IS_PREVIEW_PAGE */

import { collapseIframe } from 'Renderer/domOperations/iFrameOperations';

export const resizeOverlayContainer = () => {
  const { rootElement, activeArtboard } = store.getState(); // eslint-disable-line no-undef

  // eslint-disable-next-line max-len
  const differentialPercentage = { width: rootElement.parentNode.clientWidth / activeArtboard.viewport.width, height: rootElement.parentNode.clientHeight / activeArtboard.viewport.height };

  const adjustablePercentage = differentialPercentage[Object.keys(differentialPercentage).sort((a, b) => differentialPercentage[a] - differentialPercentage[b])[0]];

  // eslint-disable-next-line max-len
  const adjustedViewport = { width: parseInt(activeArtboard.viewport.width * adjustablePercentage, 0), height: parseInt(activeArtboard.viewport.height * adjustablePercentage, 0) };

  try {
    rootElement.style.width = `${adjustedViewport.width}px`;
    rootElement.style.height = `${adjustedViewport.height}px`;
  } catch (e) {
    console.log('ivo : error rendering overlay container');
  }
};

export const createOverlayContainer = (tagInformation, placementId, rootElementName) => {
  try {
    const rootDocument = window.top.document; // eslint-disable-line no-undef
    const overlayContainer = rootDocument.createElement('div');

    const dimensionsUnits = IS_PREVIEW_PAGE ? { width: '%', height: '%' } : { width: 'vw', height: 'vh' };
    overlayContainer.id = `ivoOverlayContainer-${tagInformation.sessionId}`;
    overlayContainer.setAttribute('data-ivo-artboard-container', '');
    overlayContainer.style.cssText = `position: fixed; left:0px; top:0px; width: 100${dimensionsUnits.width}; height: 100${dimensionsUnits.height}; z-index: 9999;`;

    const opaqueBackground = rootDocument.createElement('div');
    opaqueBackground.style.cssText = `position: absolute; width: 100${dimensionsUnits.width}; height: 100${dimensionsUnits.height}; background: rgba(0,0,0,0.4);`;
    overlayContainer.appendChild(opaqueBackground);

    const overlayWrapper = rootDocument.createElement('div');
    overlayWrapper.style.cssText = `position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 95${dimensionsUnits.width}; height: 95${dimensionsUnits.height}; `;
    overlayWrapper.id = `ivoOverlayWrapper-${tagInformation.sessionId}`;
    overlayContainer.appendChild(overlayWrapper);

    const adContainer = rootDocument.createElement('div');
    adContainer.id = rootElementName;
    adContainer.style.cssText = 'position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 100%; height: 100%; background: white;';
    overlayWrapper.appendChild(adContainer);

    const containerTarget = IS_PREVIEW_PAGE ? rootDocument.querySelector('.preview-scrollable-container') : rootDocument.body;
    containerTarget.appendChild(overlayContainer);
    return overlayContainer;
  } catch (e) {
    console.log('ivo : error rendering overlay container');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/overlayContainer.js